import React from "react";
import MultiTypeahead, { IMultiTypeaheadProps } from "./MultiTypeahead";
import { TagText, TagCloseButton, TagAvatar } from "../tag/Tag";
import { IBaseTypeaheadItem } from "./Typeahead";
import CustomTagContainer from "../tag/CustomTagContainer";

interface IGovernmentItem {
  value: string;
  label: string;
  logo: string | null;
}

interface IMultiGovernmentSelectorProps<T extends IBaseTypeaheadItem>
  extends Omit<IMultiTypeaheadProps<T>, "renderSelectedItem" | "renderItem" | "items" | "selectedItems"> {
  selectedGovernments: T[];
  governments: T[];
}

export default function MultiGovernmentSelector({
  onChange,
  selectedGovernments,
  governments,
  ...props
}: IMultiGovernmentSelectorProps<IGovernmentItem>) {
  return (
    <MultiTypeahead<IGovernmentItem>
      items={governments}
      selectedItems={selectedGovernments}
      onChange={onChange}
      renderSelectedItem={({ item, onRemove }) => (
        <CustomTagContainer selected={true} title={item.label} maxWidth="95% !important">
          <TagAvatar name={item.label} src={item.logo} />
          <TagText>{item.label}</TagText> <TagCloseButton onClick={() => onRemove(item)} />
        </CustomTagContainer>
      )}
      renderItem={({ item, active }) => (
        <CustomTagContainer active={active}>
          <TagAvatar name={item.label} src={item.logo} />
          <TagText>{item.label}</TagText>
        </CustomTagContainer>
      )}
      {...props}
    />
  );
}
